export default __webpack_public_path__ + "static/quote-video-1-static-c6ee6d041348e4d73b86a95ba90f18c1.png";